export const SRP_CONTENT_PANEL_MAX_WIDTH = '800px';
export const DESKTOP_HEADER_HEIGHT_REM = 6.125;
export const SRP_LAYOUT_SPACING_REM = 1;
